import React from "react";
import AppCheckbox from "../../../../components/AppCheckbox";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const niceToKnowItems = [
  "Error ersetzt die Description.",
  "Alignment wird selbständig gesetzt: mit Description/Error oben, sonst zentriert.",
  "labelVariant=\"body-1\" verwendet ein reguläres 14px-Label statt des standardmässigen Label 1."
];

const niceToKnowHighlights = [
  "→ Indeterminate nur für Sammel- oder Teilselektion, z.B. Tabellen oder Listen.",
];

const niceToKnowRemark = "Abstand zwischen mehreren Checkboxen kommt vom Parent-Wrapper/Layout. Ein CheckboxStack ist aktuell nicht definiert!";

function noop() {}

function PreviewRow({ label, children }) {
  return (
    <div className="ds-docs-checkbox-preview__row">
      <div className="ds-docs-checkbox-preview__label">
        <span>{label}</span>
      </div>
      <div className="ds-docs-checkbox-preview__content">{children}</div>
    </div>
  );
}

export default function CheckboxesDocs() {
  return (
    <DocsSectionCard title="Checkboxes">
      <div className="ds-docs-checkboxes">
        <div className="ds-docs-spotlight-grid ds-docs-spotlight-grid--checkboxes">
          <DocsPreviewPanel>
            <div className="ds-docs-preview-surface ds-docs-checkbox-preview">
              <div className="ds-docs-checkbox-preview__example">
                <div className="ds-docs-checkbox-preview__example-grid">
                  <AppCheckbox
                    label={
                      <span className="ds-docs-checkbox-preview__example-line">
                        Label (optional)
                      </span>
                    }
                    description={
                      <span className="ds-docs-checkbox-preview__example-line">
                        Description (optional)
                      </span>
                    }
                  />
                  <AppCheckbox
                    label={
                      <span className="ds-docs-checkbox-preview__example-line">
                        Label (optional)
                      </span>
                    }
                  />
                </div>
                <div className="ds-docs-checkbox-preview__alignment-note">
                  <strong>Alignment:</strong> Mit Description/Error sitzt die Box oben am Textblock. Ohne
                  Description/Error zentriert sie sich automatisch zur Label-Zeile.
                </div>
              </div>

              <div className="ds-docs-checkbox-preview__group">
                <div className="ds-docs-checkbox-preview__group-title">States</div>

                <PreviewRow label="Unchecked">
                  <AppCheckbox label="Option auswählen" />
                </PreviewRow>

                <PreviewRow label="Checked">
                  <AppCheckbox label="Option ausgewählt" checked onChange={noop} />
                </PreviewRow>

                <PreviewRow label="Regular label">
                  <AppCheckbox label="Option mit normaler Schrift" labelVariant="body-1" />
                </PreviewRow>

                <PreviewRow label="Indeterminate">
                  <AppCheckbox label="Teilweise ausgewählt" checked indeterminate onChange={noop} />
                </PreviewRow>

                <PreviewRow label="Error">
                  <AppCheckbox label="Bedingungen akzeptieren" error="Bitte bestätigen, bevor du fortfährst." />
                </PreviewRow>

                <PreviewRow label="Disabled">
                  <AppCheckbox
                    label="Automatisch setzen"
                    description="Momentan nicht verfügbar"
                    checked
                    disabled
                    onChange={noop}
                  />
                </PreviewRow>
              </div>
            </div>
          </DocsPreviewPanel>

          <DocsNiceToKnow
            items={niceToKnowItems}
            highlightItems={niceToKnowHighlights}
            remark={niceToKnowRemark}
            remarkTone="critical"
          />
        </div>
      </div>
    </DocsSectionCard>
  );
}
